<template>
    <div class="link-title">
        {{value}}
    </div>
</template>

<script>
    export default {
        name: "link-title",
        props: {
            value: {},
        },
    }
</script>

<style lang="scss">
    @include themeify {
        .link-title {
            position: relative;
            display: block;
            font-size: 14px;
            font-weight: 700;
            padding: 0 0 0 1em;

            &:before {
                position: absolute;
                top: 2px;
                bottom: 1px;
                left: 0;
                width: 3px;
                background-color: pl-var(color-primary);
                content: '';
            }

        }
    }
</style>